/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {IconButton, InputAdornment, TextField} from '@mui/material'
import {Clear, Search} from '@mui/icons-material'
import React, {KeyboardEventHandler} from 'react'

interface Props {
  mdDown: boolean
  value: string | undefined
  onChange: (searchString: string) => void
  onEnter?: () => void
}

const SearchBar: React.FC<Props> = ({mdDown, value, onChange, onEnter}) => {
  const keyHandler: KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (onEnter && e.key === 'Enter') {
      onEnter()
      e.preventDefault()
    }
  }

  return (
    <TextField
      sx={{padding: 2, width: '100%'}}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
        endAdornment:
          value === '' ? null : (
            <InputAdornment position="end">
              <IconButton
                aria-label='clear search bar'
                onClick={() => {
                  onChange('')
                }}
                edge="end"
              >
                <Clear />
              </IconButton>
            </InputAdornment>
          )
      }}
      autoFocus={!mdDown}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      onFocus={(event) => {
        event.target.select()
      }}
      onKeyUp={onEnter ? keyHandler : undefined}
    />
  )
}

export default SearchBar
